import {Navigate} from 'react-router'
import {AuthRedirectWrapper} from './auth-redirect'

export function DefaultPage() {
  return (
    <AuthRedirectWrapper>
      <Navigate to="/login" replace />
    </AuthRedirectWrapper>
  )
}
